import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import GlobalNav from '../components/GlobalNav';
import './Register.css';

const US_STATES = [
  ['AL','Alabama'],['AK','Alaska'],['AZ','Arizona'],['AR','Arkansas'],['CA','California'],
  ['CO','Colorado'],['CT','Connecticut'],['DE','Delaware'],['FL','Florida'],['GA','Georgia'],
  ['HI','Hawaii'],['ID','Idaho'],['IL','Illinois'],['IN','Indiana'],['IA','Iowa'],
  ['KS','Kansas'],['KY','Kentucky'],['LA','Louisiana'],['ME','Maine'],['MD','Maryland'],
  ['MA','Massachusetts'],['MI','Michigan'],['MN','Minnesota'],['MS','Mississippi'],['MO','Missouri'],
  ['MT','Montana'],['NE','Nebraska'],['NV','Nevada'],['NH','New Hampshire'],['NJ','New Jersey'],
  ['NM','New Mexico'],['NY','New York'],['NC','North Carolina'],['ND','North Dakota'],['OH','Ohio'],
  ['OK','Oklahoma'],['OR','Oregon'],['PA','Pennsylvania'],['RI','Rhode Island'],['SC','South Carolina'],
  ['SD','South Dakota'],['TN','Tennessee'],['TX','Texas'],['UT','Utah'],['VT','Vermont'],
  ['VA','Virginia'],['WA','Washington'],['WV','West Virginia'],['WI','Wisconsin'],['WY','Wyoming'],
];

export default function Register() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstname: '', lastname: '', email: '',
    password: '', confirmpassword: '', project: '', state: '',
  });
  const [captchaToken, setCaptchaToken] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  function handleChange(e) {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmpassword) {
      setError('Passwords do not match');
      return;
    }
    if (!captchaToken) {
      setError('Please complete the captcha');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch('/users/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, 'g-recaptcha-response': captchaToken }),
      });
      const data = await res.json();

      if (data.success) {
        if (data.autoLogin && data.user) {
          localStorage.setItem('user', JSON.stringify(data.user));
          window.location.href = '/hub';
        } else {
          window.location.href = '/signin?redirect=/hub';
        }
      } else if (data.exists) {
        window.location.href = '/pending';
      } else {
        setError(data.message || 'Registration failed');
      }
    } catch (err) {
      setError('An error occurred during registration');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="register-page"
      style={{ backgroundImage: "url('/images/rainbow_bg.jpg')" }}
    >
      <GlobalNav activeHref="/register" ctaLabel="Sign in" ctaHref="/signin" />

      <div className="register-wrap">
        <div className="register-panel">
          <div className="register-logo">MIHU</div>
          <h1 className="register-title">Join the collective</h1>
          <p className="register-sub">
            Apply to become part of the Music Is Healing community.
          </p>

          {error && <div className="register-error">{error}</div>}

          <form onSubmit={handleSubmit} noValidate>
            <div className="register-row">
              <div className="register-field">
                <label className="register-label" htmlFor="firstname">First name</label>
                <input id="firstname" className="register-input" type="text"
                  name="firstname" value={formData.firstname}
                  onChange={handleChange} required autoComplete="given-name" />
              </div>
              <div className="register-field">
                <label className="register-label" htmlFor="lastname">Last name</label>
                <input id="lastname" className="register-input" type="text"
                  name="lastname" value={formData.lastname}
                  onChange={handleChange} required autoComplete="family-name" />
              </div>
            </div>

            <div className="register-field">
              <label className="register-label" htmlFor="email">Email</label>
              <input id="email" className="register-input" type="email"
                name="email" value={formData.email}
                onChange={handleChange} required autoComplete="email" />
            </div>

            <div className="register-row">
              <div className="register-field">
                <label className="register-label" htmlFor="password">Password</label>
                <input id="password" className="register-input" type="password"
                  name="password" value={formData.password}
                  onChange={handleChange} required autoComplete="new-password" />
              </div>
              <div className="register-field">
                <label className="register-label" htmlFor="confirmpassword">Confirm password</label>
                <input id="confirmpassword" className="register-input" type="password"
                  name="confirmpassword" value={formData.confirmpassword}
                  onChange={handleChange} required autoComplete="new-password" />
              </div>
            </div>

            <div className="register-field">
              <label className="register-label" htmlFor="project">Project / role</label>
              <input id="project" className="register-input" type="text"
                name="project" value={formData.project}
                onChange={handleChange} placeholder="e.g. Vocalist, DJ, Producer…" />
            </div>

            <div className="register-field">
              <label className="register-label" htmlFor="state">State</label>
              <select id="state" className="register-input register-select"
                name="state" value={formData.state} onChange={handleChange}>
                <option value="">Select a state</option>
                {US_STATES.map(([val, label]) => (
                  <option key={val} value={val}>{label}</option>
                ))}
              </select>
            </div>

            <div className="register-captcha">
              <ReCAPTCHA
                sitekey="6Le5nwkjAAAAAD9avYE-E3-dheumr6LW-Hz0uMlk"
                onChange={(token) => setCaptchaToken(token)}
              />
            </div>

            <button type="submit" className="register-submit" disabled={loading}>
              {loading ? 'Creating account…' : 'Apply to join'}
            </button>

            <button type="button" className="register-signin-link"
              onClick={() => navigate('/signin')}>
              Already have an account? Sign in
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
